module.exports = __webpack_public_path__ + "img/manual-investing.ffffeefa.svg";